import { Configuration, LogLevel } from '@azure/msal-browser';

const clientId = import.meta.env.VITE_ENTRA_CLIENT_ID;
const tenantId = import.meta.env.VITE_ENTRA_TENANT_ID;
const redirectUri = import.meta.env.VITE_ENTRA_REDIRECT_URI;
const apiScope = import.meta.env.VITE_API_SCOPE;

if (!clientId || !tenantId) {
  console.warn(
    '⚠️  Variables VITE_ENTRA_CLIENT_ID / VITE_ENTRA_TENANT_ID no configuradas. ' +
    'Copia .env.example a .env.local',
  );
}

export const msalConfig: Configuration = {
  auth: {
    clientId: clientId ?? '',
    authority: `https://login.microsoftonline.com/${tenantId}`,
    redirectUri: redirectUri ?? window.location.origin,
    postLogoutRedirectUri: import.meta.env.VITE_ENTRA_POST_LOGOUT_REDIRECT_URI ?? window.location.origin,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        if (level === LogLevel.Error) console.error(message);
        if (level === LogLevel.Warning) console.warn(message);
      },
      piiLoggingEnabled: false,
    },
  },
};

export const loginRequest = {
  scopes: [apiScope ?? 'User.Read'],
};

export const apiRequest = {
  scopes: [apiScope ?? 'User.Read'],
};
